var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "IconStatus",
      style: { background: _vm.background, color: _vm.color },
    },
    [
      _c("img", {
        staticClass: "iconBox",
        attrs: { src: require(`@/icons/svg/${_vm.iconClass}.svg`), alt: "" },
      }),
      _c("span", { staticClass: "IconStatusTitle" }, [
        _vm._v(_vm._s(_vm.title)),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }